export const protectedRoutes = [
  { path: "/dashboard/overview", tag: "DASHBOARD_VIEW" },
  { path: "/dashboard/campaign-effects", tag: "DASHBOARD_VIEW" },
  { path: "/dashboard/survey-insights", tag: "DASHBOARD_VIEW" },
  { path: "/dashboard/campaign-reach", tag: "DASHBOARD_VIEW" },
  { path: "/dashboard/shop-lift", tag: "DASHBOARD_VIEW" },
  { path: "/dashboard/brand-lift", tag: "DASHBOARD_VIEW" },
  { path: "/dashboard/receipt", tag: "DASHBOARD_VIEW" },
  // Rewards
  { path: "/rewards/reward-settings", tag: "REWARD_VIEW" },
  { path: "/rewards/reward-settings/add-reward", tag: "REWARD_CREATE" },
  { path: "/rewards/reward-settings/update-reward/:id", tag: "REWARD_UPDATE" },
  { path: "/rewards/reward-settings/reward-details/:id", tag: "REWARD_VIEW" },
  { path: "/rewards/current-ranking", tag: "CURRENT_RANKING_VIEW" },
  { path: "/rewards/point-history", tag: "POINTS_MANAGEMENT" },
  { path: "/rewards/point-history/:id", tag: "POINTS_MANAGEMENT" },
  // Receipt Management
  { path: "/receipt-management", tag: "SMART_RECEIPT_VIEW" },
  { path: "/receipt-management/add-receipt", tag: "SMART_RECEIPT_CREATE" },
  {
    path: "/receipt-management/update-receipt/:id",
    tag: "SMART_RECEIPT_UPDATE",
  },
  {
    path: "/receipt-management/receipt-details/:id",
    tag: "SMART_RECEIPT_VIEW",
  },
  // Gift-Shop
  { path: "/gift-shop/gift-cards", tag: "GIFT_CARD_VIEW" },
  { path: "/gift-shop/add-gift-card", tag: "GIFT_CARD_CREATE" },
  { path: "/gift-shop/gift-card-details/:id", tag: "GIFT_CARD_VIEW" },
  { path: "/gift-shop/update-gift-card/:id", tag: "GIFT_CARD_UPDATE" },
  { path: "/gift-shop/order-history", tag: "ORDER_HISTORY_VIEW" },
  // Reporting
  { path: "/reporting/location-matching-report", tag: "REPORTING_VIEW" },
  {
    path: "/reporting/location-matching-report/:campaignId",
    tag: "REPORTING_VIEW",
  },
  { path: "/reporting/audio-matching-report", tag: "REPORTING_VIEW" },
  {
    path: "/reporting/audio-matching-report/:campaignId",
    tag: "REPORTING_VIEW",
  },
  { path: "/reporting/store-matching-report", tag: "REPORTING_VIEW" },
  {
    path: "/reporting/store-matching-report/:campaignId",
    tag: "REPORTING_VIEW",
  },
  // User Management
  { path: "/users", tag: "APP_USER_VIEW" },
  { path: "/users/add-user", tag: "APP_USER_CREATE" },
  { path: "/users/update-user/:id", tag: "APP_USER_UPDATE" },
  { path: "/users/user-details/:id", tag: "APP_USER_VIEW" },
  // Admin Management
  { path: "/admins", tag: "ADMIN_USER_VIEW" },
  { path: "/admins/add-admin", tag: "ADMIN_USER_CREATE" },
  { path: "/admins/update-admin/:id", tag: "ADMIN_USER_UPDATE" },
  { path: "/admins/admin-details/:id", tag: "ADMIN_USER_VIEW" },
  // Roles and Permissions
  { path: "/roles", tag: "ROLE_PERMISSION_MANAGEMENT" },
  // Campaigns
  { path: "/campaigns", tag: "CAMPAIGN_VIEW" },
  { path: "/campaigns/create-campaign", tag: "CAMPAIGN_CREATE" },
  { path: "/campaigns/update-campaign/:id", tag: "CAMPAIGN_UPDATE" },
  { path: "/campaigns/campaign-details/:id", tag: "CAMPAIGN_VIEW" },
  // Clients
  { path: "/clients", tag: "CLIENT_PROFILE_VIEW" },
  { path: "/clients/client-details/:id", tag: "CLIENT_PROFILE_VIEW" },
  { path: "/clients/add-client", tag: "CLIENT_PROFILE_CREATE" },
  { path: "/clients/update-client/:id", tag: "CLIENT_PROFILE_UPDATE" },
  {
    path: "/clients/update-client-locations/:id",
    tag: "CLIENT_PROFILE_UPDATE",
  },
  { path: "/clients/:id/campaigns", tag: "CAMPAIGN_VIEW" },
  { path: "/clients/:id/campaigns/campaign-details/:id", tag: "CAMPAIGN_VIEW" },
  // Surveys
  { path: "/surveys", tag: "SURVEY_VIEW" },
  { path: "/surveys/create-survey", tag: "SURVEY_CREATE" },
  { path: "/surveys/update-survey/:id", tag: "SURVEY_UPDATE" },
  { path: "/surveys/survey-details/:id", tag: "SURVEY_VIEW" },
  // Profile
  { path: "/profile", tag: "ADMIN_PROFILE_VIEW" },
  { path: "/profile/edit", tag: "ADMIN_PROFILE_UPDATE" },
  { path: "/profile/reset-password", tag: "ADMIN_PROFILE_RESET_PASSWORD" },
  { path: "/settings/static-pages", tag: "SETTING_VIEW" },
];
